import script from "./PushPermissionBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PushPermissionBanner.vue?vue&type=script&setup=true&lang=js"

import "./PushPermissionBanner.vue?vue&type=style&index=0&id=2003dfe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2003dfe2"]])

export default __exports__